<template>
  <div class="reg-modal-wrapper" id="reg-modal-d">
    <div class="reg-modal">
      <h5 class="modal-title">{{ source }} Registration</h5>

      <div class="main-scroll-modal" v-if="source == 'Singapore'">
        <template v-if="regData.parentManufacturer">
          <div class="modal-inner">
            <div class="data-title">
              <p>Parent Manufacturer</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />{{ regData.parentManufacturer }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Product Owner']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Product Owner Name</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Product Owner"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Product Owner Address']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Product Owner Address</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Product Owner Address"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Device Name']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Device Name</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Device Name"] | trimmed_text }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.productCategory">
          <div class="modal-inner">
            <div class="data-title">
              <p>Product Category (GMDN)</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />{{ regData.productCategory }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Description">
          <div class="modal-inner">
            <div class="data-title">
              <p>Description</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Description }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Medical Specialty Area']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Medical Specialty Area</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Medical Specialty Area"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Medical Device Class']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Medical Device Class</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Medical Device Class"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Risk Level']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Risk Level</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />{{ regData["Risk Level"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.registrationNumber">
          <div class="modal-inner">
            <div class="data-title">
              <p>Device Registration No</p>
            </div>
            <div class="data-value">
              <p>{{ regData.registrationNumber }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.RegistrationDate">
          <div class="modal-inner">
            <div class="data-title">
              <p>Registration Date</p>
            </div>
            <div class="data-value">
              <p>{{ regData.RegistrationDate | formatDate }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Change Notification Approval Date']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Change Notification Approval Date</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Change Notification Approval Date"] | change_approval_date }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.RegistrationDate">
          <div class="modal-inner">
            <div class="data-title">
              <p>Device System Info</p>
            </div>
            <div class="data-value">
              <p>{{ regData.RegistrationDate | formatDate }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Registrant Name']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Registrant Name</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Registrant Name"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.registrantAddress">
          <div class="modal-inner">
            <div class="data-title">
              <p>Registrant Address</p>
            </div>
            <div class="data-value">
              <p>{{ regData.registrantAddress }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.URL">
          <div class="modal-inner">
            <div class="data-title">
              <p>URL</p>
            </div>
            <div class="data-value">
              <p><a :href="regData.URL">{{ regData.URL }}</a></p>
            </div>
          </div>
        </template>
        <template v-if="regData.source">
          <div class="modal-inner">
            <div class="data-title">
              <p>Source</p>
            </div>
            <div class="data-value">
              <p>{{ regData.source }}</p>
            </div>
          </div>
        </template>
      </div>

      <div class="main-scroll-modal" v-if="source == 'Indonesia'">
        <template v-if="regData.parentManufacturer">
          <div class="modal-inner">
            <div class="data-title">
              <p>Parent Manufacturer</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />{{ regData.parentManufacturer }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.manufacturerName">
          <div class="modal-inner">
            <div class="data-title">
              <p>Manufacturer Name</p>
            </div>
            <div class="data-value">
              <p>{{ regData.manufacturerName }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.ManufacturerCompany ">
          <div class="modal-inner">
            <div class="data-title">
              <p>Manufacturer Company</p>
            </div>
            <div class="data-value">
              <p>{{ regData.ManufacturerCompany  }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.productName">
          <div class="modal-inner">
            <div class="data-title">
              <p>Product Name</p>
            </div>
            <div class="data-value">
              <p>{{ regData.productName }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.productCategory">
          <div class="modal-inner">
            <div class="data-title">
              <p>Product Category</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />{{ regData.productCategory }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.productDescription">
          <div class="modal-inner">
            <div class="data-title">
              <p>Product Description</p>
            </div>
            <div class="data-value">
              <p>{{ regData.productDescription }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.rawRiskLevel">
          <div class="modal-inner">
            <div class="data-title">
              <p>Class</p>
            </div>
            <div class="data-value">
              <p>{{ regData.rawRiskLevel }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.riskLevel">
          <div class="modal-inner">
            <div class="data-title">
              <p>Risk Level (source)</p>
            </div>
            <div class="data-value">
              <p>{{ regData.riskLevel }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Risk Level']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Risk Level(Low, Medium, High)</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Risk Level"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.registrationNumber">
          <div class="modal-inner">
            <div class="data-title">
              <p>Registration No.</p>
            </div>
            <div class="data-value">
              <p>{{ regData.registrationNumber }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Issue Date']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Issued Date</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Issue Date"] | indo_issue_date }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.expirationDate">
          <div class="modal-inner">
            <div class="data-title">
              <p>Expiration Date</p>
            </div>
            <div class="data-value">
              <p>{{ regData.expirationDate | indo_expiration_date }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.electroMedikSteritemplatetyPlusRadiationSome_">
          <div class="modal-inner">
            <div class="data-title">
              <p>Electric/Sterile</p>
              <p></p>
            </div>
            <div class="data-value">
              <p>{{ regData.electroMedikSteritemplatetyPlusRadiationSome_ }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Registrant Name']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Registrant Name</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Registrant Name"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Registrant Address']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Registrant Address</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Registrant Address"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Approval_Area">
          <div class="modal-inner">
            <div class="data-title">
              <p>Approval Division</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Approval_Area }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Product Owner']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Product Owner</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Product Owner"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.source">
          <div class="modal-inner">
            <div class="data-title">
              <p>Source</p>
            </div>
            <div class="data-value">
              <p>{{ regData.source }}</p>
            </div>
          </div>
        </template>
      </div>

      <div class="main-scroll-modal" v-if="source == 'Philippines'">
        <template v-if="regData.parentManufacturer">
          <div class="modal-inner">
            <div class="data-title">
              <p>Parent Manufacturer</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />{{ regData.parentManufacturer }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.ManufacturerName">
          <div class="modal-inner">
            <div class="data-title">
              <p>Manufacturer</p>
            </div>
            <div class="data-value">
              <p>{{ regData.ManufacturerName }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.productName">
          <div class="modal-inner">
            <div class="data-title">
              <p>Product Name</p>
            </div>
            <div class="data-value">
              <p>{{ regData.productName }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.productCategory">
          <div class="modal-inner">
            <div class="data-title">
              <p>Product Category (GMDN)</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />{{ regData.productCategory }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Type_tipe">
          <div class="modal-inner">
            <div class="data-title">
              <p>Type</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Type_tipe }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.productDescription">
          <div class="modal-inner">
            <div class="data-title">
              <p>Description</p>
            </div>
            <div class="data-value">
              <p>{{ regData.productDescription }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Risk Level']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Risk Level</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />{{ regData["Risk Level"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Country Of Origin']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Country Of Origin</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Country Of Origin"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.registrationNumber">
          <div class="modal-inner">
            <div class="data-title">
              <p>Registration Number</p>
            </div>
            <div class="data-value">
              <p>{{ regData.registrationNumber }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Trader">
          <div class="modal-inner">
            <div class="data-title">
              <p>Trader</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Trader }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Importer / Distributor']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Importer/Distributor</p>
            </div>
            <div class="data-value">
              <p>{{ regData['Importer / Distributor'] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.IssuanceDate">
          <div class="modal-inner">
            <div class="data-title">
              <p>Issuance Date</p>
            </div>
            <div class="data-value">
              <p>{{ regData.IssuanceDate | formatDate }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.expirationDate">
          <div class="modal-inner">
            <div class="data-title">
              <p>Expiry Date</p>
            </div>
            <div class="data-value">
              <p>{{ regData.expirationDate | phil_expiration_date }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.source">
          <div class="modal-inner">
            <div class="data-title">
              <p>Source</p>
            </div>
            <div class="data-value">
              <p>{{ regData.source }}</p>
            </div>
          </div>
        </template>
      </div>

      <div class="main-scroll-modal" v-if="source == 'Malaysia'">
        <template v-if="regData.parentManufacturer">
          <div class="modal-inner">
            <div class="data-title">
              <p>Parent Manufacturer</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />{{ regData.parentManufacturer }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Brand">
          <div class="modal-inner">
            <div class="data-title">
              <p>Brand</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Brand }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.device">
          <div class="modal-inner">
            <div class="data-title">
              <p>Device</p>
            </div>
            <div class="data-value">
              <p>{{ regData.device }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.productCategory">
          <div class="modal-inner">
            <div class="data-title">
              <p>Product Category (GMDN)</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />{{ regData.productCategory }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['MD / IVD']">
          <div class="modal-inner">
            <div class="data-title">
              <p>MD/IVD</p>
            </div>
            <div class="data-value">
              <p>{{ regData['MD / IVD'] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.productDescription">
          <div class="modal-inner">
            <div class="data-title">
              <p>Description</p>
            </div>
            <div class="data-value">
              <p>{{ regData.productDescription }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Intended Use']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Intended Use</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Intended Use"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Classification">
          <div class="modal-inner">
            <div class="data-title">
              <p>Classification</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Classification }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Risk">
          <div class="modal-inner">
            <div class="data-title">
              <p>Risk</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Risk }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Risk Level']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Risk Level</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />{{ regData["Risk Level"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.REGISTRATION">
          <div class="modal-inner">
            <div class="data-title">
              <p>Registration</p>
            </div>
            <div class="data-value">
              <p>{{ regData.REGISTRATION }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.VAtemplateDITY">
          <div class="modal-inner">
            <div class="data-title">
              <p>Vatemplatedity</p>
            </div>
            <div class="data-value">
              <p>{{ regData.VAtemplateDITY }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.ApprovalDate">
          <div class="modal-inner">
            <div class="data-title">
              <p>Approval Date</p>
            </div>
            <div class="data-value">
              <p>{{ regData.ApprovalDate | formatDate }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Expiration_Date">
          <div class="modal-inner">
            <div class="data-title">
              <p>Expiration Date</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Expiration_Date | mal_expiration_date }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Estabtemplateshment">
          <div class="modal-inner">
            <div class="data-title">
              <p>Estabtemplateshment/Registrant</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Estabtemplateshment }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.source">
          <div class="modal-inner">
            <div class="data-title">
              <p>Source</p>
            </div>
            <div class="data-value">
              <p>{{ regData.source }}</p>
            </div>
          </div>
        </template>
      </div>

      <div class="main-scroll-modal" v-if="source == 'Hong Kong'">
        <template v-if="regData.parentManufacturer">
          <div class="modal-inner">
            <div class="data-title">
              <p>Parent Manufacturer</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />{{ regData.parentManufacturer }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.manufacturerName">
          <div class="modal-inner">
            <div class="data-title">
              <p>Manufacturer</p>
            </div>
            <div class="data-value">
              <p>{{ regData.manufacturerName }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.BRAND">
          <div class="modal-inner">
            <div class="data-title">
              <p>Brand</p>
            </div>
            <div class="data-value">
              <p>{{ regData.BRAND }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.model">
          <div class="modal-inner">
            <div class="data-title">
              <p>Model</p>
            </div>
            <div class="data-value">
              <p>{{ regData.model }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.generalInformationAboutEquipment">
          <div class="modal-inner">
            <div class="data-title">
              <p>Equipment Name</p>
            </div>
            <div class="data-value">
              <p>{{ regData.generalInformationAboutEquipment }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Risk Level']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Level</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Risk Level"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.AMDNS_code">
          <div class="modal-inner">
            <div class="data-title">
              <p>AMDNS Code</p>
            </div>
            <div class="data-value">
              <p>{{ regData.AMDNS_code }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.AMDNS_url">
          <div class="modal-inner">
            <div class="data-title">
              <p>AMDNS Code URL</p>
            </div>
            <div class="data-value">
              <p><a :href="regData.AMDNS_url">{{ regData.AMDNS_url }}</a></p>
            </div>
          </div>
        </template>
        <template v-if="regData.AMDNS_term">
          <div class="modal-inner">
            <div class="data-title">
              <p>AMDNS Instrument Name</p>
            </div>
            <div class="data-value">
              <p>{{ regData.AMDNS_term }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.productCategory">
          <div class="modal-inner">
            <div class="data-title">
              <p>Product Category (GMDN)</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />{{ regData.productCategory }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.listing_no">
          <div class="modal-inner">
            <div class="data-title">
              <p>Listing No.</p>
            </div>
            <div class="data-value">
              <p>{{ regData.listing_no }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.revision_no">
          <div class="modal-inner">
            <div class="data-title">
              <p>Revision No.</p>
            </div>
            <div class="data-value">
              <p>{{ regData.revision_no }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Listing Expiration']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Listing Expiration</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Listing Expiration"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.remarks">
          <div class="modal-inner">
            <div class="data-title">
              <p>Remark</p>
            </div>
            <div class="data-value">
              <p>{{ regData.remarks }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.LRP">
          <div class="modal-inner">
            <div class="data-title">
              <p>Local Person in Charge</p>
            </div>
            <div class="data-value">
              <p>{{ regData.LRP }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.LRP_telephone">
          <div class="modal-inner">
            <div class="data-title">
              <p>Local Person in Charge Telephone</p>
            </div>
            <div class="data-value">
              <p>{{ regData.LRP_telephone }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.delist_date">
          <div class="modal-inner">
            <div class="data-title">
              <p>Delisting Date</p>
            </div>
            <div class="data-value">
              <p>{{ regData.delist_date | formatDate }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.source">
          <div class="modal-inner">
            <div class="data-title">
              <p>Source</p>
            </div>
            <div class="data-value">
              <p>{{ regData.source }}</p>
            </div>
          </div>
        </template>
      </div>

      <div class="main-scroll-modal" v-if="source == 'China'">
        <template v-if="regData.parentManufacturer">
          <div class="modal-inner">
            <div class="data-title">
              <p>Parent Manufacturer</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />
                {{ regData.parentManufacturer }}
              </p>
            </div>
          </div>
        </template>
        <template v-if="regData.recordType">
          <div class="modal-inner">
            <div class="data-title">
              <p>Record Type</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />
                {{ regData.recordType }}
              </p>
            </div>
          </div>
        </template>
        <template v-if="regData['Registrant Name']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Registrant Name</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Registrant Name"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.registrantAddress">
          <div class="modal-inner">
            <div class="data-title">
              <p>Registrant Address</p>
            </div>
            <div class="data-value">
              <p>{{ regData.registrantAddress }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Productionaddress">
          <div class="modal-inner">
            <div class="data-title">
              <p>Production Address</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Productionaddress }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.productName">
          <div class="modal-inner">
            <div class="data-title">
              <p>Product Name</p>
            </div>
            <div class="data-value">
              <p>{{ regData.productName }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.productCategory">
          <div class="modal-inner">
            <div class="data-title">
              <p>Product Category (GMDN)</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />
                {{ regData.productCategory }}
              </p>
            </div>
          </div>
        </template>
        <template v-if="regData.model">
          <div class="modal-inner">
            <div class="data-title">
              <p>Model</p>
            </div>
            <div class="data-value">
              <p>{{ regData.model }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['StructureandComposition - maincomponents']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Structure</p>
            </div>
            <div class="data-value">
              <p>{{ regData['StructureandComposition - maincomponents'] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['ApplicableRange - ExpectedUse']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Applicable Range/Expected Use</p>
            </div>
            <div class="data-value">
              <p>{{ regData['ApplicableRange - ExpectedUse'] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['ProductStorage - ConditionsandValidity']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Product Storage Conditions and Validity</p>
            </div>
            <div class="data-value">
              <p>{{ regData['ProductStorage - ConditionsandValidity'] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Appendix">
          <div class="modal-inner">
            <div class="data-title">
              <p>Appendix</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Appendix }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Othercontent">
          <div class="modal-inner">
            <div class="data-title">
              <p>Other Condition</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Othercontent }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Management Category']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Management Category</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Management Category"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Risk Level']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Risk Level</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />
                {{ regData["Risk Level"] }}
              </p>
            </div>
          </div>
        </template>
        <template v-if="regData.Status">
          <div class="modal-inner">
            <div class="data-title">
              <p>Status</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Status }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Registrationcertificatenumber_Chin">
          <div class="modal-inner">
            <div class="data-title">
              <p>Registration Certificate Number (Chinese)</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Registrationcertificatenumber_Chin }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Registrationcertificatenumber_Engl">
          <div class="modal-inner">
            <div class="data-title">
              <p>Registration Certificate Number (English)</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Registrationcertificatenumber_Engl }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.ApprovalDepartment">
          <div class="modal-inner">
            <div class="data-title">
              <p>Approval Department</p>
            </div>
            <div class="data-value">
              <p>{{ regData.ApprovalDepartment }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Approval Date']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Approval Date</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Approval Date"] | aus_date }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.expirationDate">
          <div class="modal-inner">
            <div class="data-title">
              <p>Expiration Date</p>
            </div>
            <div class="data-value">
              <p>{{ regData.expirationDate | indo_expiration_date }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Change">
          <div class="modal-inner">
            <div class="data-title">
              <p>Change</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Change }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.DatabaserelatedNote">
          <div class="modal-inner">
            <div class="data-title">
              <p>Database</p>
            </div>
            <div class="data-value">
              <p>{{ regData.DatabaserelatedNote }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Agentname">
          <div class="modal-inner">
            <div class="data-title">
              <p>Agent Name</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Agentname }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Agentresidence">
          <div class="modal-inner">
            <div class="data-title">
              <p>Agent Address</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Agentresidence }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.URL">
          <div class="modal-inner">
            <div class="data-title">
              <p>URL</p>
            </div>
            <div class="data-value">
              <p>
                <a :href="regData.URL"> {{ regData.URL }} </a>
              </p>
            </div>
          </div>
        </template>
        <template v-if="regData.source">
          <div class="modal-inner">
            <div class="data-title">
              <p>Source</p>
            </div>
            <div class="data-value">
              <p>{{ regData.source }}</p>
            </div>
          </div>
        </template>
      </div>
      <div class="main-scroll-modal" v-if="source == 'Vietnam'">
        <template v-if="regData.parentManufacturer">
          <div class="modal-inner">
            <div class="data-title">
              <p>Parent Manufacturer</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />{{ regData.parentManufacturer }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.manufacturerName">
          <div class="modal-inner">
            <div class="data-title">
              <p>Manufacturer</p>
            </div>
            <div class="data-value">
              <p>{{ regData.manufacturerName }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.ownerName">
          <div class="modal-inner">
            <div class="data-title">
              <p>Owner Name</p>
            </div>
            <div class="data-value">
              <p>{{ regData.ownerName }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.ownershipCountry">
          <div class="modal-inner">
            <div class="data-title">
              <p>Owner Country</p>
            </div>
            <div class="data-value">
              <p>{{ regData.ownershipCountry }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Tradenames">
          <div class="modal-inner">
            <div class="data-title">
              <p>Tradename</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Tradenames }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.model">
          <div class="modal-inner">
            <div class="data-title">
              <p>Model</p>
            </div>
            <div class="data-value">
              <p>{{ regData.model }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Unit">
          <div class="modal-inner">
            <div class="data-title">
              <p>Unit</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Unit }}</p>
            </div>
          </div>
        </template>
        <template v-if="regDatageneralInformationAboutEquipment">
          <div class="modal-inner">
            <div class="data-title">
              <p>General Information about the Device</p>
            </div>
            <div class="data-value">
              <p>{{ regDatageneralInformationAboutEquipment }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.generalNameOfTheDevice">
          <div class="modal-inner">
            <div class="data-title">
              <p>General Name</p>
            </div>
            <div class="data-value">
              <p>{{ regData.generalNameOfTheDevice }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.medicalDiscipline">
          <div class="modal-inner">
            <div class="data-title">
              <p>Medical Discipline</p>
            </div>
            <div class="data-value">
              <p>{{ regData.medicalDiscipline }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.productCategory">
          <div class="modal-inner">
            <div class="data-title">
              <p>Product Category(GMDN)</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />{{ regData.productCategory }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.medicalDiscipline">
          <div class="modal-inner">
            <div class="data-title">
              <p>Device Class</p>
            </div>
            <div class="data-value">
              <p>{{ regData.medicalDiscipline }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Risk Level']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Risk Level</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />{{ regData["Risk Level"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Group_TTBYT">
          <div class="modal-inner">
            <div class="data-title">
              <p>Group</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Group_TTBYT }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.productPrice">
          <div class="modal-inner">
            <div class="data-title">
              <p>Product Price</p>
            </div>
            <div class="data-value">
              <p>{{ regData.productPrice }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.HSCode_TTBYT">
          <div class="modal-inner">
            <div class="data-title">
              <p>HS Code</p>
            </div>
            <div class="data-value">
              <p>{{ regData.HSCode_TTBYT }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.businessNameAnnouncedPrice">
          <div class="modal-inner">
            <div class="data-title">
              <p>Name of Business that Announced the Price</p>
            </div>
            <div class="data-value">
              <p>{{ regData.businessNameAnnouncedPrice }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.enterpriseAddress">
          <div class="modal-inner">
            <div class="data-title">
              <p>Distributor Address</p>
            </div>
            <div class="data-value">
              <p>{{ regData.enterpriseAddress }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.businessTelNo">
          <div class="modal-inner">
            <div class="data-title">
              <p>Distributor Tel No (businessTelNo)</p>
            </div>
            <div class="data-value">
              <p>{{ regData.businessTelNo }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.productionCountry">
          <div class="modal-inner">
            <div class="data-title">
              <p>Country of Production</p>
            </div>
            <div class="data-value">
              <p>{{ regData.productionCountry }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData['Country Of Origin']">
          <div class="modal-inner">
            <div class="data-title">
              <p>Country Of Origin</p>
            </div>
            <div class="data-value">
              <p>{{ regData["Country Of Origin"] }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.basicConfiguration">
          <div class="modal-inner">
            <div class="data-title">
              <p>Basic Configuration</p>
            </div>
            <div class="data-value">
              <p>{{ regData.basicConfiguration }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.advancedConfiguration">
          <div class="modal-inner">
            <div class="data-title">
              <p>Advanced Configuration</p>
            </div>
            <div class="data-value">
              <p>{{ regData.advancedConfiguration }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.parametersAndSpending">
          <div class="modal-inner">
            <div class="data-title">
              <p>Parameters and Spending</p>
            </div>
            <div class="data-value">
              <p>{{ regData.parametersAndSpending }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.URL">
          <div class="modal-inner">
            <div class="data-title">
              <p>URL</p>
            </div>
            <div class="data-value">
              <p><a :href="regData.URL">{{ regData.URL }}</a></p>
            </div>
          </div>
        </template>
        <template v-if="regData.source">
          <div class="modal-inner">
            <div class="data-title">
              <p>Source</p>
            </div>
            <div class="data-value">
              <p>{{ regData.source }}</p>
            </div>
          </div>
        </template>

      </div>
      <div class="main-scroll-modal" v-if="source == 'Australia'">
        <template v-if="regData.parentManufacturer">
          <div class="modal-inner">
            <div class="data-title">
              <p>Parent Manufacturer</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />{{ regData.parentManufacturer }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Manufacturer_Name">
          <div class="modal-inner">
            <div class="data-title">
              <p>Manufacturer Name</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Manufacturer_Name }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Manufacturer_Address">
          <div class="modal-inner">
            <div class="data-title">
              <p>Manufacturer Address</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Manufacturer_Address }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Product_Name">
          <div class="modal-inner">
            <div class="data-title">
              <p>Product Name</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Product_Name }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.GMDN">
          <div class="modal-inner">
            <div class="data-title">
              <p>GMDN Code</p>
            </div>
            <div class="data-value">
              <p>{{ regData.GMDN }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.INTENDED_USE">
          <div class="modal-inner">
            <div class="data-title">
              <p>Intended Use</p>
            </div>
            <div class="data-value">
              <p>{{ regData.INTENDED_USE }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Functional_Description">
          <div class="modal-inner">
            <div class="data-title">
              <p>Functional Description</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Functional_Description }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Variant_information">
          <div class="modal-inner">
            <div class="data-title">
              <p>Variant Information</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Variant_information }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Product_Type">
          <div class="modal-inner">
            <div class="data-title">
              <p>Product Type</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Product_Type }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Category">
          <div class="modal-inner">
            <div class="data-title">
              <p>Category</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Category }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.riskLevel">
          <div class="modal-inner">
            <div class="data-title">
              <p>Risk Level</p>
            </div>
            <div class="data-value">
              <p>
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="my-inline-img"
                  alt="Asia Actual Logo"
                />{{ regData.riskLevel }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Status">
          <div class="modal-inner">
            <div class="data-title">
              <p>Status</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Status }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Artg_Entry_For">
          <div class="modal-inner">
            <div class="data-title">
              <p>Artg Entry</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Artg_Entry_For }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.ARTG_ID">
          <div class="modal-inner">
            <div class="data-title">
              <p>ARTG ID</p>
            </div>
            <div class="data-value">
              <p>{{ regData.ARTG_ID }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Effective_Date">
          <div class="modal-inner">
            <div class="data-title">
              <p>Effective Date</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Effective_Date | aus_date }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Sponsor">
          <div class="modal-inner">
            <div class="data-title">
              <p>Sponsor Name</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Sponsor }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Address">
          <div class="modal-inner">
            <div class="data-title">
              <p>Sponsor Address</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Address }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Specific_Conditions">
          <div class="modal-inner">
            <div class="data-title">
              <p>Specific Conditions</p>
            </div>
            <div class="data-value">
              <p>{{ regData.Specific_Conditions }}</p>
            </div>
          </div>
        </template>
        <template v-if="regData.Link">
          <div class="modal-inner">
            <div class="data-title">
              <p>URL</p>
            </div>
            <div class="data-value">
              <p><a :href="regData.Link">{{ regData.Link }}</a></p>
            </div>
          </div>
        </template>
        <template v-if="regData.source">
          <div class="modal-inner">
            <div class="data-title">
              <p>Source</p>
            </div>
            <div class="data-value">
              <p>{{ regData.source }}</p>
            </div>
          </div>
        </template>
      </div>

      <div class="reg-modal-footer">
        <div class="user-actions">
          <button class="orange-btn cancel" @click="closeModal">Back</button>
        </div>
        <router-link to="/">
          <img
            src="@/assets/images/common/LogoApp.svg"
            alt="Asia Actual Logo"
          />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router/index.js";
import Vue from "vue";
import moment from "moment";

Vue.filter("trimmed_text", function (value) {
  if (value) {
    let index = value.indexOf("No.Model");
    return value.slice(0, index);
  }
});

Vue.filter("formatDate", function (value) {
  if (value == "N/A") return value;
  if (value) {
    return moment(String(value), "DD/MM/YYYY").format("MMM D, YYYY");
  }
});

Vue.filter("change_approval_date", function (value) {
  if (value && value != "Not Applicable") {
    return moment(String(value), "DD/MM/YYYY").format("MMM D, YYYY");
  }
  return "Not Applicable";
});

Vue.filter("indo_issue_date", function (value) {
  if (value) {
    return moment(String(value)).format("MMM D, YYYY");
  }
});
Vue.filter("indo_expiration_date", function (value) {
  if (value) {
    return moment(String(value)).format("MMM D, YYYY");
  }
});

Vue.filter("phil_expiration_date", function (value) {
  if (value) {
    return moment(String(value)).format("MMM D, YYYY");
  }
});

Vue.filter("mal_issue_date", function (value) {
  if (value) {
    const trimmed = String(value.slice(0, 10));
    return moment(trimmed, "DD/MM/YYYY").format("MMM D, YYYY");
  }
});

Vue.filter("mal_expiration_date", function (value) {
  if (value) {
    const trimmed = String(value.slice(13, 23));
    return moment(trimmed, "DD/MM/YYYY").format("MMM D, YYYY");
  }
});
Vue.filter("aus_expiration_date", function (value) {
  if (value == "N/A") return value;
  if (value) {
    return moment(String(value)).format("MMM D, YYYY");
  }
});

Vue.filter("aus_date", function (value) {
  if (value == "N/A") return value;
  if (value) {
    return moment(String(value)).format("MMM D, YYYY");
  }
});

export default {
  props: ["regData", "source"],
  methods: {
    openURL(e) {
      window.open(e.target.innerText, "_blank");
    },
    closeModal(e) {
      let target = e.target.className;

      if (target.includes("reg-modal-wrapper")) {
        document.querySelector(".reg-modal-wrapper").style.opacity = "0";
        document.querySelector(".reg-modal-wrapper").style.zIndex = "-999";
        document.querySelector("body").style.overflow = "auto";
      } else if (target.includes("cancel")) {
        document.querySelector(".reg-modal-wrapper").style.opacity = "0";
        document.querySelector(".reg-modal-wrapper").style.zIndex = "-999";
        document.querySelector("body").style.overflow = "auto";
      }
    },
  },
};
</script>

<style lang="scss">
.reg-modal-wrapper {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: -999;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  .reg-modal {
    background: #fff;
    padding: 40px 50px;
    // margin-top: 200px;
    margin: auto;
    box-shadow: 0px 4px 15px rgba(51, 51, 51, 0.03);
    border-radius: 15px;
    width: 1000px;
    text-align: center;

    .modal-title {
      text-align: start;
      margin-bottom: 40px;
      font-size: x-large;
    }

    .data-title {
      margin-right: 40px;
      max-width: 12rem;
      min-width: 12rem;
      width: 100%;
    }
  }
  .modal-inner {
    display: flex;
    // align-items: center;

    .data-title {
      p {
        font-weight: 700;
        text-align: left;
      }
    }
    .data-value {
      text-align: left;
    }
  }
  .reg-modal-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 100px;
    .orange-btn {
      background: #fcaf05 !important;
    }
  }

  .user-actions {
    display: flex;
    justify-content: center;

    .orange-btn {
      width: 170px;
      margin: 0 10px;
      border: none;
      font-family: "Gotham-Book";

      &.cancel {
        background: #ebebeb;
        color: #333;
      }

      &:focus {
        outline: none;
      }
    }
  }
}
.main-scroll-modal {
  max-height: 34rem;
  overflow: auto;
}

.my-inline-img {
  margin-right: 10px;
  margin-bottom: 6px;
}
.clickable-url {
  cursor: pointer;
}
.clickable-url:hover {
  color: #fcaf05;
}
.img-col-d {
  position: relative;
  left: -30px;
}
</style>